import React from "react";

// ==== Import Images ====
import img05 from "../../../images/about/img05.jpg";
import img06 from "../../../images/about/img06.jpg";
import img07 from "../../../images/about/img07.jpg";
import img08 from "../../../images/about/img08.jpg";

import videoPoster from "../../../images/about/video-img.png";

import gif1 from "../../../images/icon/original-66948a0d81d.gif";
import gif2 from "../../../images/icon/0deec720000b2066289b.gif";
import gif3 from "../../../images/icon/b10c3e43e836d32554bf.gif";

import featureIcon1 from "../../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../../images/icon/feature-icon03.svg";

import aboutBg from "../../../images/bg/about-bg02.png";
import { Link } from "react-router-dom";

const AboutSection: React.FC = () => {
  return (
    <section className="about pos-rel pb-140">

      <div className="container">
        {/* ===== Top Scrolling Images ===== */}
        <div className="about-top-image ul_li_between align-items-start">

          {/* Column 1 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img05, img05, img05, img05].map((img, i) => (
                <Link key={i} to="/about">
                  <img src={img} alt="about" />
                </Link>
              ))}
            </div>
          </div>

          {/* Column 2 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img06, img06, img06, img06].map((img, i) => (
                <Link key={i} to="/about">
                  <img src={img} alt="about" />
                </Link>
              ))}
            </div>
          </div>

          {/* Video */}
          <div className="xb-video">
            <video
              loop
              muted
              playsInline
              autoPlay
              poster={videoPoster}
            >
              <source src="https://www.pexels.com/download/video/18069701/" />
            </video>
          </div>

          {/* Column 3 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img07, img07, img07, img07].map((img, i) => (
                <Link key={i} to="/about">
                  <img src={img} alt="about" />
                </Link>
              ))}
            </div>
          </div>

          {/* Column 4 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img08, img08, img08, img08].map((img, i) => (
                <Link key={i} to="/about">
                  <img src={img} alt="about" />
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* ===== Title Section ===== */}
        <div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
          <span className="sub-title mb-10">Who We are?</span>

          <h2 className="title">
            We helping
            <span><img src={gif1} alt="gif" /></span>
            grow businesses and
            <span><img src={gif2} alt="gif" /></span>
            scale with smart,
            <span><img src={gif3} alt="gif" /></span>
            data-driven AI agency
          </h2>

          <p className="content">
            We help grow and scale your business by delivering smart,
            data-driven AI solutions tailored to your needs. Our technology
            optimizes operations, enhances decision-making, and uncovers new
            opportunities for growth.
          </p>
        </div>
        <div className="mt-60">
        <p className="content mt-20">
         Brain Machine is a Data Analysis Solution and consulting company with a proven track record of over 9+ years in technology, strategy, and data. Together with our clients, Brain Machine is at the forefront of delivering innovative technological solutions for businesses of all scales worldwide: finance, healthcare, education, business management, POS inventory ecommerce and many other industries.
        </p>
        <p className="content mt-20">
        At Brain Machine, we aim at greatness and are certified to deliver it. Our commitment to building high-quality, secure, and responsible technological solutions is backed by holding ISO 9001:2015, ISO/IEC 27001:2022, ISO 14001:2015, ISO 45001:2018, and ISO 37001:2016 certifications to make sure our clients receive not only innovative but also ethical and environmentally conscious services.
        </p>
        <p className="content mt-20">
        Powered by more than 90+ seasoned professionals located in our development centers in USA, Australia, Qatar, Bangladesh, the company provides self-managed cross-functional dedicated teams to help our customers reduce development costs while increasing speed to market.
        </p>
      </div>
        {/* ===== Feature Boxes ===== */}
        <div className="row mt-40">
          {/* 1 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon">
                  <img src={featureIcon1} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Our Mission</h2>
                  <p className="xb-item--content">
                   Our mission is to empower businesses and individuals by harnessing the full potential of the digital landscape. We are committed to delivering innovative web solutions that not only meet but exceed our clients’ expectations. Through creativity, collaboration.
                  </p>
                  <p className="xb-item--content">
                   Brain Machine enable to collect the update machine learning world’s information and make it universally accessible and useful.
                  </p>
                  <p className="xb-item--content">
                  To move the web forward and give web designers and developers the best tools and services in the world.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon">
                  <img src={featureIcon2} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Our Vision</h2>
                  <p className="xb-item--content">
                    Our vision is to be a trailblazing force in the world of web design and development, recognized for our unwavering commitment to excellence, integrity, and customer satisfaction.
                  </p>
                  <p className="xb-item--content">
                   Moreover, leading Web Solution company in IT sector and progress in our current position in market. We know that Customer’s growth is our growth, so we commit our customers to help in achieving their business goals. We believe in work with the accuracy and best quality. We want to be known as the reliable software service provider in IT industry.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 3 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon">
                  <img src={featureIcon3} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Core Values</h2>
                  <p className="xb-item--content">
                      Brain Machine connecting businesses with their audiences, and individuals with their dreams. Our path forward is one of continuous growth.
                      Brain Machine Doing the right thing and being transparent in interactions with employees, customers, and stakeholders. Taking responsibility for actions and making things right when mistakes happen.
                  </p>
                  <p className="xb-item--content">
                      We following innovative ideas and theories to develop new services and leads. Going above and beyond to satisfy customer needs and issues.
                      
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      
      </div>

      {/* Background */}
      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
